// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_landing__Content from "../../../core/Content.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Buhta_models__Locale from "../../../../../../packages/models/Locale.js";
import * as Stdlib__List from "melange/list.js";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function CompanyDetailsPage(Props) {
  const intl = ReactIntl.useIntl();
  const language = Buhta_landing__Route.getLanguage(undefined);
  const match = Buhta_landing__Content.Context.useContent(undefined);
  const requisites = match[0].requisites;
  const binLabel = Buhta_landing__I18n.trans(intl, "bin");
  const kbeLabel = Buhta_landing__I18n.trans(intl, "kbe");
  const phoneLabel = Buhta_landing__I18n.trans(intl, "phone");
  const iikLabel = Buhta_landing__I18n.trans(intl, "iik");
  const bikLabel = Buhta_landing__I18n.trans(intl, "bik");
  const innLabel = Buhta_landing__I18n.trans(intl, "inn");
  const okpoLabel = Buhta_landing__I18n.trans(intl, "okpo");
  const accountLabel = Buhta_landing__I18n.trans(intl, "account");
  const okedLabel = Buhta_landing__I18n.trans(intl, "oked");
  const mfoLabel = Buhta_landing__I18n.trans(intl, "mfo");
  const details = Stdlib__List.map((function (r) {
    const phone = r.phone;
    const address = r.address;
    const bank = r.bank;
    const name = r.name;
    const bin = Belt__Belt_Option.getWithDefault(r.bin, "-");
    const kbe = Belt__Belt_Option.getWithDefault(r.kbe, "-");
    const iik = Belt__Belt_Option.getWithDefault(r.iik, "-");
    const bik = Belt__Belt_Option.getWithDefault(r.bik, "-");
    const inn = Belt__Belt_Option.getWithDefault(r.inn, "-");
    const oked = Belt__Belt_Option.getWithDefault(r.oked, "-");
    const okpo = Belt__Belt_Option.getWithDefault(r.okpo, "-");
    const account = Belt__Belt_Option.getWithDefault(r.account, "-");
    const mfo = Belt__Belt_Option.getWithDefault(r.mfo, "-");
    const match = r.country;
    switch (match) {
      case "kg" :
        return {
          country: Buhta_models__Locale.getCountryLocale(/* COUNTRY_KGZ */ 2, language),
          text: "" + name + "\n" + innLabel + " " + inn + "\n" + okpoLabel + " " + okpo + "\n\n" + address + "\n" + phoneLabel + ": " + phone + "\n\n" + accountLabel + ": " + account + "\n" + bank + "\n" + bikLabel + ": " + bik
        };
      case "kz" :
        return {
          country: Buhta_models__Locale.getCountryLocale(/* COUNTRY_KAZ */ 1, language),
          text: "" + name + "\n" + binLabel + ": " + bin + "\n" + kbeLabel + ": " + kbe + "\n\n" + address + "\n" + phoneLabel + ": " + phone + "\n\n" + bank + "\n" + iikLabel + ": " + iik + "\n" + bikLabel + ": " + bik
        };
      case "uz" :
        return {
          country: Buhta_models__Locale.getCountryLocale(/* COUNTRY_UZB */ 3, language),
          text: "" + name + "\n" + innLabel + ": " + inn + "\n" + okedLabel + ": " + oked + "\n\n" + address + "\n" + phoneLabel + ": " + phone + "\n\n" + accountLabel + ": " + account + "\n" + bank + "\n" + mfoLabel + ": " + mfo
        };
      default:
        return {
          country: "",
          text: ""
        };
    }
  }), requisites);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h1", {
        children: Buhta_landing__I18n.trans(intl, "company_details"),
        className: "h4 lg:h2 text-black-landing mb-6 lg:mb-10"
      }),
      Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, d) {
        const Key = "company_detail_" + String(i);
        return JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("p", {
              children: d.text,
              className: "paragraph text-black-landing whitespace-pre-line"
            }),
            className: "pb-6"
          })
        }, Key);
      }), details))
    ],
    className: "pt-10 lg:pt-0 px-6 sm:px-48 lg:px-0"
  });
}

const make = CompanyDetailsPage;

export {
  make,
}
/* Buhta_landing__Content Not a pure module */
